import { numberToPrettyString, plural } from '@cian/utils';

import * as React from 'react';

import { Footer } from '../../../components/AdvancedFiltersComponent/components/Footer';
import { useFiltersContext } from '../../../utils/context';

import { trackProfessionalSearchClick } from './tracking';

export interface IAdvancedFiltersFooterContainerProps {
  onClearClick(): void;
  onShowClick(): void;
}

export const AdvancedFiltersFooterContainer: React.FC<IAdvancedFiltersFooterContainerProps> = ({
  onClearClick,
  onShowClick,
}) => {
  const { jsonQueryCount, jsonQueryCountRefreshing, isProfessionalSearchButtonVisible, queryString } =
    useFiltersContext();
  const professionalSearchUrl = getProfessionalSearchUrlWithFilters(queryString);
  const searchButtonText = getSearchButtonText(jsonQueryCount);

  return (
    <Footer
      isCounterRefreshing={jsonQueryCountRefreshing}
      isProfessionalSearchButtonVisible={isProfessionalSearchButtonVisible}
      professionalSearchUrl={professionalSearchUrl}
      searchButtonText={searchButtonText}
      onClearClick={onClearClick}
      onProfessionalSearchClick={trackProfessionalSearchClick}
      onShowClick={onShowClick}
    />
  );
};

function getSearchButtonText(offersCount: number | undefined): string {
  return `Показать ${
    typeof offersCount !== 'undefined'
      ? `${numberToPrettyString(offersCount)} ${plural(offersCount, ['объект', 'объекта', 'объектов'])}`
      : 'объекты'
  }`;
}

const HOST_PART = 'https://my.cian.ru/offers';

function getProfessionalSearchUrlWithFilters(queryString: string | undefined): string {
  const encodeQueryString =
    queryString && queryString.includes('cat.php?') ? encodeURIComponent(queryString.split('cat.php?')[1]) : '';

  return encodeQueryString ? `${HOST_PART}?from_full_url=${encodeQueryString}` : HOST_PART;
}
